"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

const ROUTES = {
  CAMPAIGNS: "/campaigns",
  EVENTS: "/events",
};

export default function HeaderStyleController({ site }) {
  const pathname = usePathname();
  const headerRef = useRef(null);

  useEffect(() => {
    if (!headerRef.current) {
      headerRef.current = document.querySelector("header");
    }
    if (!headerRef.current) return;

    const isDisabledPages =
      pathname.startsWith(`/${site.setting?.routes?.venueDetail}`) ||
      [
        site.setting?.routes?.generalList,
        ROUTES.CAMPAIGNS,
        ROUTES.EVENTS,
      ].includes(pathname);

    headerRef.current.classList.toggle("header-disabled", isDisabledPages);
  }, [pathname]);

  return null;
}
